import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@/stores/auth';

type Props = { children: ReactNode };

export const RequireAuth = ({ children }: Props) => {
  const authed = useIsAuthenticated();
  const loc = useLocation();
  if (!authed) return <Navigate to="/auth/login" state={{ from: loc.pathname }} replace />;
  return <>{children}</>;
};
